module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"et":{"Continue with {provider}":"Sisene {provider} kontoga","{provider}":"{provider}"}}')
  delete Component.options._Ctor
}
